import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface SummaryMetric {
  count: number;
  percentage: number;
}

export interface AttendanceMonthSummaryData {
  totalWorkingDays: SummaryMetric;
  totalLeaveTaken: SummaryMetric;
  totalHolidays: SummaryMetric;
  totalHalfDays: SummaryMetric;
}

export type AttendanceMonthSummaryResponse = {
  success: boolean;
  data: AttendanceMonthSummaryData;
  message?: string;
};

const fetchAttendanceMonthSummary = async (
  month = new Date().getMonth() + 1,
  year = new Date().getFullYear()
): Promise<AttendanceMonthSummaryResponse> =>
  (
    await customAxios.get<AttendanceMonthSummaryResponse>(
      `/reports/attendance/monthSummary?month=${month}&year=${year}`
    )
  ).data;

export const useGetAttendanceMonthSummary = (
  month = new Date().getMonth() + 1,
  year = new Date().getFullYear()
) =>
  useQuery<AttendanceMonthSummaryResponse, AxiosError>(
    ["attendanceMonthSummary", month, year],
    () => fetchAttendanceMonthSummary(month, year),
    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Attendance Summary",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load attendance month summary",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
